/**
 * Typography tokens: font families, sizes, weights, line heights, letter spacing.
 */

export const fontFamilies = {
  sans: 'Geist, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  display: '"Funnel Display", Geist, ui-sans-serif, system-ui, sans-serif',
  mono: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
};
export const fontSizes = {
  xs: '0.75rem',
  // 12px
  sm: '0.875rem',
  // 14px
  base: '1rem',
  // 16px
  lg: '1.125rem',
  // 18px
  xl: '1.25rem',
  // 20px
  '2xl': '1.5rem',
  // 24px
  '3xl': '1.875rem',
  // 30px
  '4xl': '2.25rem',
  // 36px
  '5xl': '3rem',
  // 48px (Speakflow hero size)
  '6xl': '3.75rem',
  // 60px
};
export const fontWeights = {
  normal: '400',
  medium: '500',
  semibold: '600',
  bold: '700',
  extrabold: '800',
};
export const lineHeights = {
  none: '1',
  tight: '1.25',
  snug: '1.375',
  normal: '1.5',
  relaxed: '1.625',
  loose: '2',
};
export const letterSpacings = {
  tighter: '-0.05em',
  tight: '-0.025em',
  normal: '0em',
  wide: '0.025em',
  wider: '0.05em',
  widest: '0.1em',
};
